<template>
    <div>
        <el-form ref="formData"  class="mrt20 formadd" size="mini" label-width="120px" :model="formData" :inline="true" :rules="rules">
            <div>

                <el-form-item label="ID"  prop="i_id">{{formData.i_id}}</el-form-item>
                <el-form-item label="名称:" prop="vc_name" required>
                    <el-input v-model="formData.vc_name"  size="mini" @input="vc_nameChange"></el-input>
                </el-form-item >

                <el-form-item label="合同显示名称:"  prop="vc_name_nick" required>
                    <el-input v-model="formData.vc_name_nick" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="英文名:"  prop="vc_ename"　 required>
                    <el-input v-model="formData.vc_ename" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="是否外销"class="w50"  prop="i_isexport" required>
                    <el-radio-group v-model="formData.i_isexport" >
                        <el-radio :label='0'>否</el-radio>
                        <el-radio :label='1'>是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item  prop="vc_exname" label="外贸品名:" :required="formData.i_isexport==1">
                    <el-input  class="changeinput" size="mini" v-model="formData.vc_exname"  ></el-input>
                </el-form-item>

                <el-form-item label="产地:"  prop="vc_cd">
                    <el-input v-model="formData.vc_cd" clearable size="mini" :disabled="ifdisabled"></el-input>
                </el-form-item>
                <el-form-item label="厂家:"  prop="vc_gykh">
                    <el-input v-model="formData.vc_gykh" clearable size="mini" :disabled="ifdisabled"></el-input>
                </el-form-item>

                    <el-form-item label="包装规格:" class="w50"  prop="vc_bzstyle">
                        <el-input  v-model="formData.vc_bzstyle" clearable size="mini" :disabled="ifdisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="包装单位:" prop="vc_bzunit" class="w50">
                        <el-select v-model="formData.vc_bzunit" style="width: 100%" filterable clearable size="mini" :disabled="ifdisabled">
                            <el-option
                                    v-for="item in bzdwList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="转换比率:" prop="f_bl" class="w50" required>
                        <el-input-number class="w100" :controls="false" v-model="formData.f_bl" clearable size="mini" :disabled="ifdisabled" :precision="6" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="单件净重:" prop="f_weight" class="w50" required>
                        <el-input-number class="w100" :controls="false" v-model.number="formData.f_weight"  size="mini" :disabled="ifdisabled" :precision="4" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="件重单位:" prop="vc_djunit" class="w50" required>
                        <el-select v-model="formData.vc_djunit" style="width: 100%" filterable  size="mini" :disabled="ifdisabled">
                            <el-option
                                    v-for="item in jzdwList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                        </el-select>
                    </el-form-item>



                    <el-form-item label="所属板块:" prop="i_sector_id" class="w50" required>
                        <el-select v-model="formData.i_sector_id"  size="mini" @change="changeSector" :remote="true"
                                   :remote-method="bksearch"   style="width: 100%" >
                            <el-option
                                    v-for="item in bkList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货物性质:" prop="vc_type" class="w50" required>
                        <el-select  v-model="formData.vc_type" style="width: 100%"   size="mini" :disabled="ifdisabled">
                            <el-option
                                    v-for="item in things"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item label="产品属性:" prop="i_flag" class="w50" required>
                    <el-select  v-model="formData.i_flag" style="width: 100%" size="mini"  disabled>
                        <el-option
                                v-for="item in flagList"
                                :key="item.i_flag"
                                :label="item.vc_flag"
                                :value="item.i_flag">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计价单位:" prop="vc_priceunit" class="w50">
                    <el-select v-model="formData.vc_priceunit" style="width: 100%" filterable clearable size="mini" disabled>
                        <el-option
                                v-for="item in dictList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计量单位:" prop="vc_unit" class="w50" required>
                    <el-select v-model="formData.vc_unit" style="width: 100%" filterable  size="mini" :disabled="ifdisabled||data.i_id!=0">
                        <el-option
                                v-for="item in dictList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型:" class="w50"  prop="i_isprocess" required>
                    <el-select   class="marr4" v-model="formData.i_isprocess" size="mini"  placeholder="请选择类型">
                        <el-option v-for="item in jgList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联产品:" prop="i_relate_id" v-if="formData.i_isprocess!=2">
                    <div @click="chooseNameglcp" style="cursor: pointer" :class="baseerp+'color'">{{formData.vc_relate_pz?formData.vc_relate_pz:'选择关联产品'}}</div>
                </el-form-item >
                    <el-form-item label="是否用包装物:"class="w50"  prop="isusepack" required>
                        <el-radio-group :disabled="ifdisabled" v-model="formData.isusepack" >
                            <el-radio :label='0'>否</el-radio>
                            <el-radio :label='1'>是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否启用:"class="w50"  prop="isuse" required>
                        <el-radio-group :disabled="ifdisabled" v-model="formData.isuse" >
                            <el-radio :label='0'>否</el-radio>
                            <el-radio :label='1'>是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否传电商:" class="w50"  prop="isec" required>
                        <el-radio-group :disabled="ifdisabled" v-model="formData.isec" >
                            <el-radio :label='0'>否</el-radio>
                            <el-radio :label='1'>是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="卸货是否必检:" class="w50"  prop="i_ismustcheck" required>
                        <el-radio-group :disabled="ifdisabled" v-model="formData.i_ismustcheck" >
                            <el-radio :label='0'>否</el-radio>
                            <el-radio :label='1'>是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否化验:" class="w50"  prop="i_assayres" required>
                        <el-radio-group :disabled="ifdisabled" v-model="formData.i_assayres" >
                            <el-radio :label='0'>否</el-radio>
                            <el-radio :label='1'>是</el-radio>
                        </el-radio-group>
                    </el-form-item>
<!--                <el-form-item label="是否加工:" class="w50"  prop="i_isprocess" required>-->
<!--                    <el-radio-group disabled v-model="formData.i_isprocess" >-->
<!--                        <el-radio :label='0'>否</el-radio>-->
<!--                        <el-radio :label='1'>是</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->

                <el-form-item label="是否计件:" class="w50"  prop="isjian" required>
                    <el-radio-group disabled v-model="formData.isjian" >
                        <el-radio :label='0'>否</el-radio>
                        <el-radio :label='1'>是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="散水/非散水:" class="w50"  prop="i_isbulk" required>
                    <el-radio-group disabled v-model="formData.i_isbulk" >
                        <el-radio :label='1'>散水</el-radio>
                        <el-radio :label='0'>非散水</el-radio>
                    </el-radio-group>
                </el-form-item>
<!--                <el-form-item label="ERP库存核算:"   prop="i_pzid_kcjs_sel" required>-->
<!--                    <el-radio-group :disabled="ifdisabled" v-model="formData.i_pzid_kcjs_sel" >-->
<!--                        <el-radio :label='0'>大类ID</el-radio>-->
<!--                        <el-radio :label='1'>规格ID</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
                <el-form-item  prop="i_syncyy_type" label="用友同步方式" disabled required>
<!--                    <el-radio-group disabled v-model="formData.i_syncyy_type" >-->
<!--                        <el-radio :label='1'>按产品</el-radio>-->
<!--                        <el-radio :label='2'>按规格</el-radio>-->
<!--                    </el-radio-group>-->
                    <span v-if="formData.i_syncyy_type==1">按产品</span>
                    <span v-if="formData.i_syncyy_type==2">按规格</span>
                </el-form-item>
                <el-form-item label="用友code:" class="w50"  prop="vc_code_yongyou" v-if="formData.i_syncyy_type==2">
                    <span style="margin-right: 3px">{{formData.vc_code_yongyou}}</span>
                    <el-button v-if="formData.i_id!=0" type="text" @click="tosync('用友')">同步</el-button>
                </el-form-item>
                <el-form-item label="南北code:" class="w50"  prop="vc_code_nanbei">
                    <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
                    <el-button v-if="formData.i_id!=0" type="text" @click="tosync('南北')">同步</el-button>
                </el-form-item>
                <el-form-item label="财务成本核算:"   prop="i_type_sel" required >
<!--                        {{formData.i_type_sel?'规格ID':'大类ID'}}-->
                        <el-radio-group  :disabled="formData.i_syncyy_type==1" v-model="formData.i_type_sel" >
                            <el-radio :label='0'>按产品</el-radio>
                            <el-radio :label='1'>按批次</el-radio>
                        </el-radio-group>
                    </el-form-item>
                <el-form-item  prop="i_ispno" label="ERP统计粒度" required>
                    <el-radio-group disabled v-model="formData.i_ispno" >
                        <el-radio :label='2'>规格</el-radio>
                        <el-radio :label='3'>批次</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <el-table border ref="sgtable1" size="mini" v-if="formData.i_syncyy_type==2&&distributedList.length>0" :data="distributedList" :height="tableHeight-100"
                  :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <!--            <el-table-column  align="center"   type="selection" width="50px" ></el-table-column>-->
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column  prop="vc_gsname"  label="下发公司"  show-overflow-tooltip>
<!--                <template slot-scope="scope">-->
<!--                    <el-select class="marr4 w100"  v-model="scope.row.i_gsid" size="mini"  filterable >-->
<!--                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column  prop="vc_pz_attr"  label="属性"  show-overflow-tooltip>
<!--                <template slot-scope="scope">-->
<!--                    <el-select  class="marr4 w100"  v-model="scope.row.i_pz_attr" size="mini" clearable filterable >-->
<!--                        <el-option v-for="item in flagList" :key="item.i_flag" :label="item.vc_flag" :value="item.i_flag">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </template>-->
            </el-table-column>
<!--            <el-table-column label="操作" width="40" align="center">-->
<!--                <template slot="header" slot-scope="scope" >-->
<!--                    <el-button  icon="el-icon-plus" @click="addRow"   size="mini"  type="text" ></el-button>-->
<!--                    &lt;!&ndash;                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>&ndash;&gt;-->
<!--                </template>-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button  icon="el-icon-minus" type="text" v-if="scope.row.i_id==0" @click="deletepz(scope.row,scope.$index)"  size="mini"></el-button>-->
<!--                    &lt;!&ndash;                    <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>&ndash;&gt;-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>

            <div class="flex">
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveadd('formData')" size="small" :class="baseerp+'btn'" v-if="isuse" :disabled="disabled">保存</el-button>

            <el-button @click="resetFormson()"  size="small" >{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog title="选择关联产品" width="80%" :class="baseerp+'div'" top="30px" v-if="glcpVisible" :visible.sync="glcpVisible" append-to-body :modal-append-to-body="true" :close-on-click-modal="false">
            <guan-lian-pz :data="glcpData" @close="glcpClose"></guan-lian-pz>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import GuanLianPz from "./GuanLianPz";

    export default {
        name:"ChanpinGuige",
        components:{GuanLianPz},

        props: {
            data: {
                type: Object,
                required: true,
            }
        },

        data(){
            var validateExname = (rule, value, callback) => {
                if (value === ''&&this.formData.i_isexport==1) {
                    callback(new Error('请输入外贸品名'));
                } else {
                    callback();
                }
            };
            return{
                tableHeight:0,

                baseerp:'',
                formadd:{},
                before:{},
                formData:{
                    i_id: "",
                    vc_name: "",
                    vc_name_nick: "",
                    vc_ename: "",
                    vc_exname: "",
                    vc_cd: "",
                    vc_gykh: "",
                    vc_bzstyle: "",
                    vc_bzunit: "",
                    f_bl: 1.00,
                    vc_unit: "吨",
                    f_weight: 0,
                    i_isbulk:0,
                    vc_type:"普货",
                    vc_djunit:"KG",
                    isec: 0,
                    isjian: 0,
                    i_flag: "",
                    i_type_sel:0,
                    isusepack:0,
                    i_ispno:3,
                    i_pzid_kcjs_sel:1,isuse:1,i_ismustcheck:0,i_assayres:0,
                    i_isprocess:0,vc_exname:'',i_syncyy_type:'',
                    vc_priceunit: "吨",i_isexport:0,i_sector_id:'',vc_relate_pz:'',i_relate_pzid:0,
                    vc_code_yongyou:'',
                    vc_code_nanbei:'',
                    i_meteringunit_id:0,
                    i_priceunit_id:0,
                    i_unitgroup_id:0,
                },
                distributedList:[],
                subscribeData:[],
                dictList:[],
                jzdwList:[],
                flagList:[],
                bzdwList:[],
                things:[{i_id:'危险品',vc_name:'危险品'},{i_id:'普货',vc_name:'普货'}],
                disabled:false,
                ifdisabled:false,
                bkList:[],
                bk_seaech:'',
                jgList:[{i_id:0,vc_name:'默认'},{i_id:1,vc_name:'受托加工'},{i_id:2,vc_name:'研发'},{i_id:3,vc_name:'委外加工'}],
                glcpData:{},
                glcpVisible:false,
                rules:{
                    vc_name:[{required: true,message:'请输入名称'}],
                    vc_name_nick:[{required: true,message:'请输入合同显示名称'}],
                    vc_ename:[{required: true,message:'请输入英文名称'}],
                    f_weight:[{required: true,message:'请输入单件净重'}],
                    vc_unit:[{required: true,message:'请选择计量单位'}],
                    vc_type:[{required: true,message:'请选择货物性质'}],
                    f_bl:[{required: true,message:'请输入转换比率'}],
                    i_sector_id:[{required: true,message:'请输入所属板块'}],
                    i_flag:[{required: true,message:'请选择产品属性'}],
                    vc_exname:[{validator:validateExname,trigger: 'blur'}],

                },
                isuse:true,

            }
        },

        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        //console.log(this.data,'this.data')
                        if(this.data.i_id==0){
                            this.formData.i_flag=this.data.i_flag;
                            this.formData.i_mdid=this.data.i_mdid;
                            this.formData.i_id=this.data.i_id;
                            this.formData.vc_name=this.data.vc_name;
                            this.formData.vc_name_nick=this.data.vc_name_nick;
                            this.formData.vc_ename=this.data.vc_ename;
                            this.formData.i_pzid_kcjs_sel=this.data.i_pzid_kcjs_sel;
                            this.formData.i_type_sel=this.data.i_type_sel;
                            this.formData.i_sector_id=this.data.i_sector_id;
                            // this.formData.i_ispno=this.data.i_ispno?this.data.i_ispno:3;
                            this.formData.vc_unit=this.data.vc_unit?this.data.vc_unit:'';
                            this.formData.vc_priceunit=this.data.vc_priceunit?this.data.vc_priceunit:'';
                            this.formData.i_meteringunit_id=this.data.i_meteringunit_id?this.data.i_meteringunit_id:0
                            this.formData.i_priceunit_id=this.data.i_priceunit_id?this.data.i_priceunit_id:0
                            this.formData.i_unitgroup_id=this.data.i_unitgroup_id?this.data.i_unitgroup_id:0
                            // this.formData.i_isexport=this.data.i_isexport?this.data.i_isexport:0;
                            // this.formData.vc_exname=this.data.vc_exname?this.data.vc_exname:'';
                            this.formData.i_isprocess=this.data.i_isprocess;
                            this.formData.isjian=this.data.isjian;
                            this.formData.i_isbulk=this.data.i_isbulk;
                            this.formData.i_ispno=this.data.i_ispno;
                            this.formData.i_syncyy_type=this.data.i_syncyy_type;
                            let now=this.$DateTime.now();
                            this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");
                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data))
                            this.isuse=JSON.parse(JSON.stringify(this.data)).isuse

                            this.getSpecificationDistributeList()
                        }
                    }
                    // console.log('------------',this.data)
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted(){
            // this.getCompanyList();
            this.getSectorList();
            this. getDictList('unit');
            this. getDictList('jzdw');
            this. getDictList('bzdw');
            this. findClassificationAttributes();
            // let now=this.$DateTime.now();
            //
            // this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
            // this.formData.vc_lruname=sessionStorage.getItem("lruname");
            // this.formData.i_lruid=sessionStorage.getItem("userid");
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            tosync(text){
                this.$confirm('是否同步到'+text+'系统','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    console.log(this.formData,"this.formData")
                    this.updatesystem(text);
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
            },
            async updatesystem(text){
                let param={
                    i_id:this.formData.i_id,
                };
                let res={};
                if(text=='用友'){
                    res=await API.saveYYProductSpecification(param);
                }
                if(text=='南北'){
                    res=await API.saveSNProductSpecification(param);
                }
                if ( res.code == 1 ){
                    if(res.data){
                        if(text=='用友'){
                            this.formData.vc_code_yongyou=res.data;
                        }
                        if(text=='南北'){
                            this.formData.vc_code_nanbei=res.data;
                        }
                        this.$message.success(res.message);
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            vc_nameChange(){
                this.$set(this.formData,'vc_name_nick',this.formData.vc_name);
                // console.log(this.formData.vc_name_nick,'this.formData.vc_name_nick')
                // this.formData.vc_name_nick=this.formData.vc_name
                // this.$forceUpdate()
            },
            chooseNameglcp(){
                this.glcpData={
                    i_leixing:this.formData.i_isprocess
                }
                this.glpzOpen()
            },
            glpzOpen(){
                this.glcpVisible=true
            },
            glcpClose(val){
                //console.log(val,'val--')
                if(val){
                    this.formData.vc_relate_pz=val.vc_name+' '+val.vc_cd+' '+val.vc_gykh+' '+val.vc_bzstyle;
                    this.formData.i_relate_pzid=val.i_id;
                }
                this.glcpVisible=false
            },
            // addRow(){
            //     this.formData.distributedList.unshift({
            //         i_gsid:'',
            //         i_pz_attr:'',
            //         i_id:0,
            //     })
            // },
            // deletepz(row,index){
            //     this.formData.distributedList.splice(index,1);
            //     // if(row.id!=0)this.formData.delgoods.push(row.id);
            //     // this.getSum(row,index)
            // },
            //单位接口(计量单位)
            async getDictList(type){
                let param={
                    vc_type:'unit',
                    i_isweightunit:type=='jzdw'?1:-1,
                    i_unitgroup_id:type=='jzdw'||type=='bzdw'?'':this.formData.i_unitgroup_id,
                    vc_unit_parent:type=='jzdw'||type=='bzdw'?'':null,

                };
                let res=await API.getDictList(param);
                if (res.code==1){
                    //console.log(res,"getDict");
                    if(type=='unit'){
                        this.dictList=res.data;

                    }else if(type=='jzdw'){
                        this.jzdwList=res.data;

                    }else if(type=='bzdw'){
                        this.bzdwList=res.data;
                    }
                    // this.jzdwList=res.data;
                    //console.log(this.dictList,"this.dictList")
                }
            },
            resetFormson(){
                // this.formData={};
                this.$emit('close',null)
                //console.log(this.formData,"this.formData")
            },

            //新增里保存按钮
            saveadd(formName) {
                // if (this.data.title!="新增产品大类"&&this.data.title!="编辑产品大类"){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        this.addOrupdateProductSpecification();
                        this.disabled=true;
                    }else{
                        return false
                    }
                })
            },
            saveaddNew() {
                this.$emit('getMDSysMessage');
                //this.$emit('getMDSysMessage');
                // this.resetFormson();
            },
            ///新增接口
            async addOrupdateProductSpecification() {
                this.formData.operate=this.formData.i_id?1:0;
                // this.formData.i_pzid=this.data.i_pzid;
                this.formData.i_pid=this.data.i_pzid;
                this.formData.i_typeid=this.data.i_pztypeid;
                this.formData.vc_app=this.baseerp;
                this.formData.isyw=0;
                let now=this.$DateTime.now();
                this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.formData.i_lruid=sessionStorage.getItem("userid");
                let param=this.formData;
                let res = await API.addOrupdateProductSpecification(param);
                if (res.code == 1) {
                    this.$emit('close','save');
                    this.$message.success(res.message);
                    this.disabled=false

                    //console.log(res, "addOrupdateProductSpecification");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    this.disabled=false

                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                };
            },
            async findClassificationAttributes(){
                let param={
                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.flagList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            bksearch(e){
                this.bk_seaech=e
                this.getSectorList()
            },
            changeSector(){
                if(this.formData.i_sector_id){
                    this.formData.vc_sector_name=this.bkList.find(g=>g.i_id==this.formData.i_sector_id).vc_name
                }else{
                    this.formData.vc_sector_name=''
                }
            },
            async getSectorList(){
                let param={
                    "vc_search":this.bk_seaech,
                    "i_isuse":1,
                    "pageSize":50,
                    "currentPage":1
                };
                let res=await API.getSectorList(param);
                if ( res.code == 1 ){
                    this.bkList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getSpecificationDistributeList(){
                let param={
                    i_id:this.formData.i_id
                };
                let res=await API.getSpecificationDistributeList(param);
                if ( res.code == 1 ){
                    this.distributedList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        }
    }

</script>

<style lang="scss" scoped>
    .flex{
        display: flex;

    }
    .inputW{
        width: calc(100% - 100px);
    }
    .mrl20{
        margin-left: 20px;
    }

    .mrr50{
        margin-right:100px;
    }

    .cl{
        clear: both;
    }

    .fl{
        float: left;
    }

    .fr{
        float: right;
    }
    .w50{
        width: 50%;
    }
    .w100{
        width: 100%;
    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }

    /deep/{
        .el-form-item__content{
            width: 230px;
         }
        /*.upload-input[data-v-a4d5ba82]{*/
        /*    right:160px;*/
        /*    bottom: 10px;*/
        /*}*/
    }
    .el-radio{
        margin-right: 12px;
    }
    .el-radio:last-child{
        margin-right: 0;
    }
    div .el-form-item{
        width: 350px;

    }

</style>